module.exports = __webpack_public_path__ + "static/media/tn.6abbdbb8.svg";